import {ListConfigs} from '../../../../../sharedComponent/SearchList/SearchList.types'

export const CUSTOMERAUDITLISTCONFIGS: ListConfigs[] = [
  {
    headerName: 'User Email',
    apiFieldName: 'userEmail',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'User Role',
    apiFieldName: 'role',
    columnWidth: '150',
    type: 'TEXT',
  },
  {
    headerName: 'Date / Time',
    apiFieldName: 'timeChanged',
    columnWidth: '150',
    type: 'LOCALTIME',
  },
]

export const customerlogdummy = [
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
  {
    userRole: 'System Admin',
    userEmail: 'vendorsys@mailinator.com',
    dateTime: '12 Nov',
    fieldName: 'First Name',
    oldData: 'Jane',
    newData: 'Veronica',
  },
]
